import React, { useState } from "react";
import ENTRELOGO from "../images/ENTRELOGO.png";
import { supabase } from "../cloudflareClient";
import "./home.css";

function Home() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError("Email ou mot de passe incorrect.");
    } else {
      window.location.href = "/facteur-editeur";
    }

    setLoading(false);
  };

  return (
    <div className="home-center-container">
      <img src={ENTRELOGO} alt="Logo" className="home-logo" />
      <h1 className="home-title">Connexion à votre espace</h1>
      <form className="home-login-form" onSubmit={handleSubmit}>
        <input
          className="effect-1"
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          className="effect-1"
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {error && <div style={{ color: "#c00", fontSize: "0.98rem" }}>{error}</div>}
        <button type="submit" className="login-btn" disabled={loading}>
          {loading ? "Connexion..." : "Se connecter"}
        </button>
      </form>

      {/* Footer */}
      <footer style={{ marginTop: "2rem", fontSize: "0.85rem", color: "#666" }}>
        © {new Date().getFullYear()} Aghenda. Tous droits réservés.
      </footer>
    </div>
  );
}

export default Home;
